import Base from "./base";

export default class Nuvei extends Base {
	constructor(props) {
		super(props);
	}

	makeExternalPayment(newStep) {
		const { stake, selectedCurrency } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(stake),
				claimsBonus: false,
				currency: selectedCurrency,
				method: this.props.externalFunc.method,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { stake, selectedCurrency } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(stake),
				claimsBonus: true,
				bonusId: bonusId,
				currency: selectedCurrency,
				method: this.props.externalFunc.method,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}
}
